module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "transition-item animated",
    staticStyle: {
      "animation-duration": ".8s"
    },
    style: ({
      'transform': _vm.transStyle
    }),
    attrs: {
      "id": "repo-detail",
      "transition": "zoom"
    }
  }, [_c('div', {
    staticClass: "animated bounceInRight"
  }, [_c('repo-content', {
    attrs: {
      "repo": _vm.repo
    }
  })], 1), _vm._v(" "), _c('div', {
    ref: "tabwrapper",
    attrs: {
      "id": "repo-tabs-wrapper"
    }
  }, [_c('div', {
    staticClass: "animated bounceInRight",
    attrs: {
      "id": "repo-tabs"
    }
  }, _vm._l((_vm.TABS), function(tab) {
    return _c('div', {
      staticClass: "repo-tab-item",
      class: {
        'selected': (_vm.activeTab === tab.key)
      },
      on: {
        "click": function($event) {
          return _vm.switchTab(tab)
        }
      }
    }, [_vm._v("\n                " + _vm._s(tab.value) + "\n            ")])
  }), 0)]), _vm._v(" "), (_vm.loadFailed) ? _c('div', {
    staticClass: "offline-msg"
  }, [_vm._v("\n        You are offline!\n        "), _c('div', {
    staticClass: "blue-link",
    on: {
      "click": _vm.getProfile
    }
  }, [_vm._v("Try again")])]) : _vm._e(), _vm._v(" "), _c('div', {
    ref: "tabcontent",
    attrs: {
      "id": "repo-tab-content"
    }
  }, [_c('div', {
    staticClass: "repo-content-item markdown-body",
    class: {
      'show': (_vm.activeTab === 'readme')
    },
    attrs: {
      "id": "readme"
    }
  }, [_c('vue-markdown', {
    attrs: {
      "source": _vm.readme
    }
  }), _vm._v(" "), (!_vm.readme) ? _c('div', {
    staticClass: "empty-data"
  }, [_vm._v("No data")]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "repo-content-item",
    class: {
      'show': (_vm.activeTab === 'files')
    },
    attrs: {
      "id": "files"
    }
  }, [_vm._l((_vm.contents), function(content) {
    return [_c('div', {
      staticClass: "file-item"
    }, [_c('div', {
      staticClass: "file-icon"
    }, [(content.type === 'file') ? _c('i', {
      staticClass: "fa fa-file-text-o"
    }) : _c('i', {
      staticClass: "fa fa-folder"
    })]), _vm._v(" "), _c('div', {
      staticClass: "file-info"
    }, [_c('div', {
      staticClass: "file-name"
    }, [_vm._v(_vm._s(content.name))]), _vm._v(" "), _c('div', {
      staticClass: "file-date"
    }, [_vm._v("\n                          " + _vm._s(_vm._f("transToSize")(content.size)) + "\n                      ")])])])]
  }), _vm._v(" "), (!_vm.contents.length) ? _c('div', {
    staticClass: "empty-data"
  }, [_vm._v("No data")]) : _vm._e()], 2), _vm._v(" "), _c('div', {
    staticClass: "repo-content-item",
    class: {
      'show': (_vm.activeTab === 'contributors')
    },
    attrs: {
      "id": "contributors"
    }
  }, [_vm._l((_vm.contribs), function(contrib) {
    return _c('div', {
      staticClass: "contrib-item"
    }, [_c('div', {
      staticClass: "contrib-avatar",
      style: ({
        'backgroundImage': ("url('" + (contrib.avatar_url) + "')")
      })
    }), _vm._v(" "), _c('div', {
      staticClass: "contrib-info"
    }, [_c('div', {
      staticClass: "contrib-name"
    }, [_vm._v(_vm._s(contrib.login))]), _vm._v(" "), _c('div', {
      staticClass: "contrib-value"
    }, [_vm._v(_vm._s(contrib.contributions) + " " + _vm._s(' ') + "\n                        contribution" + _vm._s(contrib.contributions === 1 ? '' : 's') + "\n                    ")])])])
  }), _vm._v(" "), (!_vm.contribs.length) ? _c('div', {
    staticClass: "empty-data"
  }, [_vm._v("No data")]) : _vm._e()], 2), _vm._v(" "), _c('div', {
    staticClass: "repo-content-item",
    class: {
      'show': (_vm.activeTab === 'languages')
    },
    attrs: {
      "id": "languages"
    }
  }, [_vm._l((_vm.languages), function(language) {
    return _c('div', {
      staticClass: "lang-item"
    }, [_c('div', {
      staticClass: "lang-color",
      style: ({
        backgroundColor: _vm.getColor(language.name)
      })
    }), _vm._v(" "), _c('div', {
      staticClass: "lang-info"
    }, [_c('div', {
      staticClass: "lang-name"
    }, [_vm._v(_vm._s(language.name))]), _vm._v(" "), _c('div', {
      staticClass: "lang-value"
    }, [_vm._v(_vm._s(language.value) + "%")])])])
  }), _vm._v(" "), (!_vm.languages.length) ? _c('div', {
    staticClass: "empty-data"
  }, [_vm._v("No data")]) : _vm._e()], 2)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-e70ab636!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/RepoDetail.vue
// module id = 469
// module chunks = 2